<template>
  <section class="section-b-space contact-info help-bg" :class="{ 'd-none d-sm-block' : !hidemobile }" :style="{backgroundImage: pageObj.footer_image ? `url(${pageObj.footer_image})`:'url(/img/bg-book.jpg)'}">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h2>{{_T_DB(pageObj,'footer_heading') || _T('You still have a question?') }}</h2>
          <h5>
            {{_T_DB(pageObj,'footer_text') || _T('If you cannot find answer to your question in our FAQ, you can always contact us.')}}
          </h5>
          <a :href="pageObj.footer_url||'#'">
            <b-button class="" size="lg"> {{_T_DB(pageObj,'footer_b_text')|| _T('Contact Us')}} </b-button>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StaticFooter',
  props: {
    pageObj: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      mobileHide: [
        'contact_us',
        'faq'
      ],
    }
  },
  computed: {
    ...mapGetters(['_T','_T_DB']),
    hidemobile() {
      if (
        this.$route.matched.some(({ name }) => this.mobileHide.includes(name))
      ) {
        return false
      } else {
        return true
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.help-bg {
  padding: calc(#{$px40} + (90 - 40) * ((100vw - #{$px320}) / (1920 - 320))) 0;
  color: $font-color;
  &::after {
      background: $light-border;
  }
}
.contact-info {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 100%;
  text-align: center;
  padding: calc(#{$px60} + (136 - 60) * ((100vw - #{$px320}) / (1920 - 320))) 0;
  position: relative;
  z-index: 1;
  &::after {
      background-color: $color-tertiary;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.8;
      z-index: -1;
  }
  h2,h5 {
      color: $white;
      letter-spacing: -0.8px;
      text-transform: inherit;
      font-weight: normal;
      margin: -6px 0 calc(#{$px30} + (38 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
  }
  .btn {
      color: $white;
      background: $color-primary;
      transition: 1s ease;
      &:hover, &:focus, &:active {
        color: $color-primary;
        background: $white;
      }
  }
}
</style>
